export default function AlertDashboardChartController(
  $scope,
  AlertsService,
  gettextCatalog,
  usersService,
) {
  'ngInject';

  var drawDonutChart = function (numOne, numTwo, perc, color1, color2, percDivId, chartid) {
    if (numOne === 0 && numTwo === 0) {
      numTwo = 100;
    }

    var width = 100;
    var height = 100;
    var radius = 50;
    var donutWidth = 10;

    var svg = d3
      .select('#' + chartid)
      .append('svg')
      .attr('style', 'margin-left:auto; margin-right:auto; display:block;')
      .attr('width', width)
      .attr('height', height);

    var g = svg.append('g').attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');

    var text = g
      .append('text')
      .attr('text-anchor', 'middle')
      .attr('style', 'font-size:2.0em;')
      .attr('dy', '0.5em');

    text.text('' + perc + '%');

    var arc = d3.svg
      .arc()
      .innerRadius(radius - donutWidth) // UPDATED
      .outerRadius(radius);

    var pie = d3.layout
      .pie()
      .value(function (d) {
        return d.count;
      })
      .sort(null);

    var dataset = [
      {
        product: 'High',
        count: numOne,
        color: color1,
      },
      {
        product: 'Not High',
        count: numTwo,
        empty: true,
        color: color2,
      },
    ];

    var slices = pie(dataset);

    var path = g
      .selectAll('path')
      .data(slices)
      .enter()
      .append('path')
      .attr('class', 'slice')
      .attr('d', arc)
      .attr('fill', function (d, i) {
        return d.data.color;
      });
  };

  //Low Priority Chart
  var drawLowPriorityChart = function () {
    var lowPriorityCount = $scope.lowPriorityNum;
    var others = $scope.highPriorityNum + $scope.mediumPriorityNum;
    var lowPrioritypercentage = $scope.lowPriorityPerc;

    drawDonutChart(
      lowPriorityCount,
      others,
      lowPrioritypercentage,
      '#1990BF',
      '#BDBDBD',
      '#cnt',
      'donutChartLowPriority',
    );
  };

  var drawMediumPriorityChart = function () {
    var mediumPriorityCount = $scope.mediumPriorityNum;
    var others = $scope.lowPriorityNum + $scope.highPriorityNum;
    var mediumPrioritypercentage = $scope.mediumPriorityPerc;

    drawDonutChart(
      mediumPriorityCount,
      others,
      mediumPrioritypercentage,
      '#FFB74D',
      '#BDBDBD',
      '#cntMedium',
      'donutChartMediumPriority',
    );
  };

  var drawHighPriorityChart = function () {
    var highPriorityCount = $scope.highPriorityNum;
    var others = $scope.lowPriorityNum + $scope.mediumPriorityNum;
    var highPrioritypercentage = $scope.highPriorityPerc;

    drawDonutChart(
      highPriorityCount,
      others,
      highPrioritypercentage,
      '#EF5350',
      '#BDBDBD',
      '#cntHigh',
      'donutChartHighPriority',
    );
  };

  $scope.loadingChart = true;
  //ON INIT
  var refresh = function () {
    AlertsService.getAllAlerts().then(
      function (response) {
        let currentUser = usersService.currentUser();
        let visibleDatapoints = {};
        currentUser.visibleDatapoints.forEach((dp) => {
          visibleDatapoints[dp.id] = dp;
        });

        $scope.highPriorityNum = 0;
        $scope.mediumPriorityNum = 0;
        $scope.lowPriorityNum = 0;
        let total = 0;
        response.data.forEach((item) => {
          if (visibleDatapoints[item.series.tags[0]]) {
            if (item.priority.toLowerCase() === 'low') $scope.lowPriorityNum++;
            else if (item.priority.toLowerCase() === 'medium') $scope.mediumPriorityNum++;
            else if (item.priority.toLowerCase() === 'high') $scope.highPriorityNum++;
            total++;
          }
        });

        $scope.lowPriorityPerc = Math.round(($scope.lowPriorityNum / total) * 100);
        $scope.mediumPriorityPerc = Math.round(($scope.mediumPriorityNum / total) * 100);
        $scope.highPriorityPerc = Math.round(($scope.highPriorityNum / total) * 100);

        if (
          angular.element('#donutChartLowPriority').length &&
          angular.element('#donutChartMediumPriority').length &&
          angular.element('#donutChartHighPriority').length
        ) {
          drawLowPriorityChart();
          drawMediumPriorityChart();
          drawHighPriorityChart();
        }
        $scope.loadingChart = false;
      },
      function (error) {
        var errorMsg = gettextCatalog.getString('An error occurred while generating alert charts');
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg =
              error.data.message +
              ' ' +
              (error.status.toString() + ' - ' + error.statusText.toString());
          } else {
            errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        $scope.loadingChart = false;
        $scope.onLoadErrorFlag = true;
        $scope.onLoadErrorText = errorMsg;
      },
    );
  };

  refresh();

  $scope.$watch('alertGetCleared', function (newValue, oldValue) {
    if (newValue != oldValue) {
      refresh();
    }
  });
}
